import { render, staticRenderFns } from "./EmployeeMessagesDialog.vue?vue&type=template&id=28a037ec&scoped=true&lang=pug&"
import script from "./EmployeeMessagesDialog.vue?vue&type=script&lang=ts&"
export * from "./EmployeeMessagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeMessagesDialog.vue?vue&type=style&index=0&id=28a037ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a037ec",
  null
  
)

export default component.exports